<template>
  <div>
      <HeaderIndex></HeaderIndex>
      <div class="w1100">
       	<div class="marginT10">
        	<div class="is-postion fb">
                <div class="is-posbg">您当前的位置： <a href="/">网站首页</a> / <span style="color:#F70000;">先锋搜索</span>
            	</div>
          	</div>
			    <div style="border:1px solid #ccc; border-top:none;">
            	<div style="padding:49px 0 50px 240px; background:url(../searchpage_bg.jpg) 800px no-repeat;">
            		<div class="floatL fb f14" style="line-height:30px;">关键字：</div>
                <div class="floatL">
                  <el-input v-model="searchKey" placeholder="请输入内容" size="small"></el-input>
                </div>
                <div class="floatL" style="margin-left:13px;">
                    <el-select clearable v-model="selectChannelId" placeholder="请选择对应栏目搜索" size="small">
                      <el-option 
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                </div>
                <div class="floatL" style="margin-left:13px;">
                  <el-button type="danger" size="small" @click="getContent()">搜索</el-button>
                </div>
                <div class="clear"></div>
                </div>
                <div class="searchList">
                    <div style="padding-top:10px" v-for="item in list" :key="'search'+item.id">
                            <div class="search_TR f14">
                                <div class="tit" id="black_14">
                                  <a :href="'/qsxf-web/detail?id='+item.id" :title="item.title" target="_blank">{{item.title}}</a>
                                  </div>
                                <div class="time">{{item.timePublish}}</div>
                            </div>
                    </div>
                    <div style="width:974px; height:32px; text-align:center;margin:20px 0;">
                      <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="pageIndex"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="totalCount">
                      </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="clear"></div>
    </div>
      <FooterIndex name="footerIndex"></FooterIndex>
  </div>
</template>


<script>

import FooterIndex from './FooterIndex'
import HeaderIndex from './HeaderIndex'
import request from '@/common/request'
import  '../assets/css/css.css'

export default {
  name: 'SearchIndex',
  data () {
    return {
      searchKey:"",
      selectChannelId:"",
      pageIndex:1,
      pageSize:10,
      list:[],
      totalCount:0,
      options: [{
          value: '6144',
          label: '魅力潜山'
        }, {
          value: '6145',
          label: '时政资讯'
        }, {
          value: '6146',
          label: '潜阳要闻'
        }, {
          value: '6758',
          label: '先锋文汇'
        }, {
          value: '6148',
          label: '主题活动'
        }],
        currentPage: 1
    }
  },
  components: {
      FooterIndex,HeaderIndex
  },
  mounted() {
    this.searchKey = this.$route.query.key;
    this.getContent();
  },
  watch: {
    $route(to, from){
      this.searchKey = this.$route.query.key;
      this.getContent();
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getContent();
    },
    getContent:function(){
      this.getSearchContent().then(data=>{
        if(data.result && data.result.totalCount > 0 && data.result.list){
          this.list = data.result.list;
          this.totalCount = data.result.totalCount;
        }else{
          this.list = [];
          this.totalCount = 0;
        }
      });
    },
    getSearchContent:function(){
      return request({
        url: '/index/getSearchContent',
        method: 'get',
        params: { 
          "key":this.searchKey,
          "pageIndex":this.pageIndex,
          "pageSize":this.pageSize,
          "channelId":this.selectChannelId
        }
      })
    }
  }
}
</script>

<style scoped>
.searchList {
    width:1072px;
    margin-left: 13px;
    border-top: 1px solid #E0E0E0;
  }
  .search_TR {
    height: 28px;
    background:url(/images/doc_B.jpg) 11px center no-repeat;
    line-height: 28px;
  }
  .search_TR .tit {
    float: left;
    height: 28px;
    width: 900px;
    padding-left: 22px;
  }
  .search_TR .time {
    float: left;
    height: 28px;
    width: 150px;
    color:#666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchIndex.vue